/**
 * For supported service types,
 * https://stamps.atlassian.net/browse/WEBAPPS-30894
 */

export default Object.freeze({
	// USPS supported service types
	UspsFirstClassMail: 'usps_first_class_mail', // 'USFC',
	UspsGroundAdvantage: 'usps_ground_advantage', // 'USGA'
	UspsPriorityMail: 'usps_priority_mail', // 'USPM',
	UspsPriorityMailExpress: 'usps_priority_mail_express', // 'USXM',
	UspsMediaMail: 'usps_media_mail', // 'USMM',
	UspsParcelSelect: 'usps_parcel_select', // 'USPS',
	UspsFirstClassMailIntl: 'usps_first_class_mail_international', // 'USFCI',
	UspsPriorityMailIntl: 'usps_priority_mail_international', // 'USPMI',
	UspsPriorityMailExpressIntl: 'usps_priority_mail_express_international', // 'USEMI',
	UspsPayOnUseReturn: 'usps_pay_on_use_return', // 'USRETURN',

	// UPS supported service types
	UpsNextDayAirEarly: 'ups_next_day_air_early', // 'UPSNDAE'
	UpsNextDayAir: 'ups_next_day_air', // 'UPSNDA'
	UpsNextDayAirSaver: 'ups_next_day_air_saver', // 'UPSNDAS'
	Ups2ndDayAirAm: 'ups_2nd_day_air_am', // 'UPS2DAA'
	Ups2ndDayAir: 'ups_2nd_day_air', // 'UPS2DA'
	Ups3DaySelect: 'ups_3_day_select', // 'UPS3DS'
	UpsGround: 'ups_ground', // 'UPSGD'
	UpsGroundSaver: 'ups_ground_saver', // 'UPSGDS'
	UpsStandard: 'ups_standard', // 'UPSSD'
	UpsWorldwideExpress: 'ups_worldwide_express', // 'UPSWES'
	UpsWorldwideExpressPlus: 'ups_worldwide_express_plus', // 'UPSWESP'
	UpsWorldwideExpedited: 'ups_worldwide_expedited', // 'UPSWED'
	UpsWorldwideSaver: 'ups_worldwide_saver', // 'UPSWSR'

	// DHL Express supported service types
	DhlExpressWorldwide: 'dhl_express_worldwide', // 'DHLEWW'

	// FedEx supported service types
	FedExFirstOvernight: 'fedex_first_overnight', // 'FXFO'
	FedExPriorityOvernight: 'fedex_priority_overnight', // 'FXPO'
	FedExStandardOvernight: 'fedex_standard_overnight', // 'FXSO'
	FedEx2DayAm: 'fedex_2day_am', // 'FX2DAM'
	FedEx2Day: 'fedex_2day', // 'FX2D'
	FedEx2DayOneRate: 'fedex_2day_one_rate', // 'FX2DOR'
	FedExExpressSaver: 'fedex_express_saver', // 'FXES'
	FedExGround: 'fedex_ground', // 'FXGD'
	FedExGroundEconomy: 'fedex_ground_economy_parcel_select', // 'FXGEPS'
	FedExHomeDelivery: 'fedex_home_delivery', // 'FXHD'
	FedExIntlFirst: 'fedex_international_first', // 'FXFI'
	FedExIntlPriority: 'fedex_international_priority', // 'FXPI'
	FedExIntlEconomy: 'fedex_international_economy', // 'FXEI'
	FedExIntlGround: 'fedex_international_ground', // 'FXGDI'
	FedExIntlConnectPlus: 'fedex_international_connect_plus', // 'FXICP'

	// GlobalPost supported service types
	GlobalPostFirstClassSmartSaver: 'globalpost_first_class_smartsaver', // 'SCGPFCSS',
	GlobalPostParcelSelectSmartSaver: 'globalpost_parcel_select_smartsaver', // 'SCGPPSSS'
	GlobalPostEconomyIntl: 'globalpost_economy', // 'SCGPE'
	GlobalPostEconomyIntlSmartSaver: 'globalpost_economy_smartsaver', // 'SCGPESS'
	GlobalPostStandardIntl: 'globalpost_standard', // 'SCGPP'
	GlobalPostStandardIntlSmartSaver: 'globalpost_standard_smartsaver', // 'SCGPPSS'
	GlobalPostPlus: 'globalpost_plus', // 'SCGPL'
	GlobalPostPlusSmartSaver: 'globalpost_plus_smartsaver', // 'SCGPLSS'
	// New GlobalPost service types (codes per backend MailClassV25.cs)
	GlobalPostFlatRate: 'globalpost_go', // 'SCGPG'
	GlobalPostEdge: 'globalpost_edge_domestic', // 'SCGPED'
	GlobalPost2DayPromise: 'globalpost_2_day_promise', // 'SC2DP' (SWSIM wire: "SC-2DP")
	GlobalPostGdeGroundAdvantage: 'globalpost_gde_ground_advantage', // 'SCGPGDEGA'
	GlobalPostGdePriorityMail: 'globalpost_gde_priority_mail', // 'SCGPGDEPM'
	GlobalPostPlusDutiesAndTaxes: 'globalpost_plus_duties_and_taxes', // 'SCGPDT'

	// CanadaPost supported service types
	CanadaPostRegularParcel: 'canada_post_regular_parcel',
	CanadaPostXpresspost: 'canada_post_xpresspost',
	CanadaPostPriority: 'canada_post_priority',
	CanadaPostExpeditedParcel: 'canada_post_expedited_parcel',
	CanadaPostSmallPacketAirUsa: 'canada_post_small_packet_air_usa',
	CanadaPostTrackedPacketUsa: 'canada_post_tracked_packet_usa',
	CanadaPostExpeditedParcelUsa: 'canada_post_expedited_parcel_usa',
	CanadaPostXpresspostUsa: 'canada_post_xpresspost_usa',
	CanadaPostPriorityWorldwideUsa: 'canada_post_priority_worldwide_usa',
	CanadaPostSmallPacketIntlSurface:
		'canada_post_small_packet_international_surface',
	CanadaPostSmallPacketIntlAir: 'canada_post_small_packet_international_air',
	CanadaPostIntlParcelSurface: 'canada_post_international_parcel_surface',
	CanadaPostIntlParcelAir: 'canada_post_international_parcel_air',
	CanadaPostTrackedPacketIntl: 'canada_post_tracked_packet_international',
	CanadaPostXpresspostIntl: 'canada_post_xpresspost_international',
	CanadaPostPriorityWorldwideIntl:
		'canada_post_priority_worldwide_international',
});
